var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 21.25C31.25 21.25 31.25 25 27.5 22.5V15C27.5 13.625 26.375 12.5 25 12.5H17.5C15 8.75 18.75 8.75 18.75 5C18.75 2.23875 16.5112 0 13.75 0C10.9887 0 8.75 2.23875 8.75 5C8.75 8.75 12.5 8.75 10 12.5H2.5C1.125 12.5 0 13.625 0 15V37.5C0 38.875 1.125 40 2.5 40H10C12.5 36.25 8.75 36.25 8.75 32.5C8.75 29.7388 10.9887 27.5 13.75 27.5C16.5112 27.5 18.75 29.7388 18.75 32.5C18.75 36.25 15 36.25 17.5 40H25C26.375 40 27.5 38.875 27.5 37.5V30C31.25 27.5 31.25 31.25 35 31.25C37.7612 31.25 40 29.0112 40 26.25C40 23.4888 37.7612 21.25 35 21.25Z",
    fill: "url(#paint0_linear_1072_425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1072_425",
    x1: 0.734375,
    y1: 39.2663,
    x2: 27.9106,
    y2: 12.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.b918f25a954bd7507c2a2dadcd2b4543.svg";
export { ForwardRef as ReactComponent };